import { useState } from "react";

const AmenitiesTabTripjack = ({ hotelDetails }) => {
    const [showAll, setShowAll] = useState(false);
    const maxItemsToShow = 10;
    const services = hotelDetails?.hotel?.fl || [];
    const itemsToShow = showAll ? services : services.slice(0, maxItemsToShow);

    const handleToggleShowAll = () => {
        setShowAll(!showAll);
    };

    return (
        <div className="amenities">
            <h4 className="my-4">Amenities</h4>
            <h5 className='mb-2'>Services & Equipments</h5>
            <div>
                <ul className='Hotel_services'>
                    {itemsToShow.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
                {services.length > maxItemsToShow && (
                    <button type='link' className='read-more-button' onClick={handleToggleShowAll}>
                        {showAll ? 'Show Less' : 'Read More'}
                    </button>
                )}
            </div>
        </div>
    );
};

export default AmenitiesTabTripjack;